import React from 'react'

const SwitchFromTo = (props) => {

    const { isFrom, setIsFrom } = props;

    return (
        <div 
            className={`flex w-44 h-10 px-1 rounded-full text-white font-semibold items-center cursor-pointer select-none ${isFrom ? 'justify-end bg-blue-500' : 'justify-start bg-emerald-500'}`}
            onClick={() => setIsFrom(!isFrom)}
            >
                    {isFrom && <div className='w-[70%] text-center'>Agent To User</div>}
                    <span className={`flex items-center justify-center w-8 h-8 rounded-full bg-white`}>
                        
                    </span>
                    {!isFrom && <div className='w-[70%] text-center'>User To Agent</div>}
        </div>
    )
}

export default SwitchFromTo